import { withStyles, WithStyles } from '@material-ui/core/styles';
import { FC } from 'react';

import { styles } from './SingleGroupSelect.styles';
import { GroupSelect, GroupSelectProps, SingleGroupSelectOnChange } from '../GroupSelect';

export interface SingleGroupSelectProps
  extends Omit<GroupSelectProps, 'classes' | 'defaultValue' | 'multiple' | 'onChange' | 'value'>,
    WithStyles<typeof styles> {
  defaultValue?: Id;
  value: Id;
  onChange?: SingleGroupSelectOnChange;
}

const SingleGroupSelectComponent: FC<SingleGroupSelectProps> = ({ onChange, ...groupSelectProps }) => {
  return (
    <GroupSelect
      {...groupSelectProps}
      multiple={false}
      onChange={(value, option) => {
        if (onChange) {
          onChange(value as Id, option);
        }
      }}
    />
  );
};

export const SingleGroupSelect = withStyles(styles)(SingleGroupSelectComponent);
